import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { XsrfService } from './xsrf.service';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn : 'root',
})
export class XsrfHttpInterceptor implements HttpInterceptor {

  xsrfService = inject(XsrfService);
  environmentService = inject(EnvironmentService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   if (req.url.includes(this.environmentService.apiBaseUrl()) && !req.url.endsWith('xsrf')){
      return next.handle(req.clone(
        {
          headers: req.headers.set('x-csrf-token', this.xsrfService.token),
          withCredentials: true
        },
      ))
    }
    return next.handle(req);
  }
}
